import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

export interface DisplaySection { id: number; tag_name: string; allowed_type_ids: number[] }

export function getDisplaySections(): Promise<DisplaySection[]> {
  return apiFetch<DisplaySection[]>('/display-sections');
}
export function useDisplaySections() {
  return useQuery({ queryKey: ['display-sections'], queryFn: getDisplaySections, staleTime: 60 * 60 * 1000 });
}

export interface BoardTopic { id: number; topic_no: string; title: string; type_id: number; sort_index: number }
export interface BoardSection { id: number; tag_name: string; topics: BoardTopic[] }

export function getSectionBoard(): Promise<BoardSection[]> {
  return apiFetch<BoardSection[]>('/display-sections/board');
}
export function setSectionTopics(sectionId: number, topicIds: number[]): Promise<BoardSection[]> {
  return apiFetch<BoardSection[]>(`/display-sections/${sectionId}`, {
    method: 'PUT',
    body: JSON.stringify({ topic_ids: topicIds }),
  });
}
export function useSectionBoard() {
  return useQuery({ queryKey: ['section-board'], queryFn: getSectionBoard });
}
